import * as React from 'react';
import HideInMobile from 'src/_common/quillElements/fragment/HideinMobile';
import ShowInMobile from 'src/_common/quillElements/fragment/ShowInMobile';
import {
  CircularProgress,
  Grid,
  Container,
  styled,
} from '@quillbot/design-system';
import { makeStyles } from '@quillbot/design-system';
import { createStyles } from '@quillbot/design-system';

const useStyles = makeStyles((theme) =>
  createStyles({
    loader: {
      borderRadius: '13px',
      boxShadow: 'rgba(31, 31, 31, 0.15) -1px 4px 12px 0px',
      position: 'relative',
      margin: 0,
      padding: 0,
      // backgroundColor: 'rgba(235, 244, 238, 0.69)',
    },

    bgColorbody: {},
  })
);

const StyledLoader = styled(Grid)`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 13px;
  height: calc(50vh + 105px);
  @media only screen and (max-width: 767px) {
    height: calc(50vh + 140px);
  }
`;

interface IProps {
  isWriter?: boolean;
  isGrammarChecker?: boolean;
}

function LoadingBar(props: IProps) {
  let loaderHeight = '0';
  let marginTop = '0';
  if (props.isGrammarChecker) {
    loaderHeight = '30vh';
    marginTop = '75px';
  } else if (props.isWriter) {
    loaderHeight = 'calc(100vh - 109px)';
  }
  return (
    <div className="circular-loader">
      <ShowInMobile>
        {/* <div
          style={{
            height: 42,
            backgroundColor: 'rgba(235, 244, 238, 0.69)',
          }}
        />
        <div style={{ borderTop: '1px solid #e1e1e1' }} />
        <div
          style={{
            height: 25,
            backgroundColor: 'rgba(235, 244, 238, 0.69)',
          }}
        /> */}
        <Grid
          item
          xs={12}
          style={{
            marginTop: 70,
            padding: 0,
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress color="secondary" />
        </Grid>
      </ShowInMobile>
      <HideInMobile>
        <Container
          maxWidth={false}
          className={
            props.isWriter || props.isGrammarChecker
              ? ''
              : 'root-container home-container-gray'
          }
        >
          <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            style={
              props.isWriter || props.isGrammarChecker
                ? { marginTop: marginTop }
                : {
                    borderRadius: '13px',
                    boxShadow: 'rgba(31, 31, 31, 0.15) -1px 4px 12px 0px',
                    position: 'relative',
                    margin: 0,
                    padding: 0,
                  }
            }
          >
            <StyledLoader
              item
              xs={12}
              style={{
                height: loaderHeight ? loaderHeight : undefined,
              }}
            >
              <CircularProgress />
            </StyledLoader>
          </Grid>
        </Container>
      </HideInMobile>
    </div>
  );
}

export default LoadingBar;
